import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import baguetteBox from 'baguettebox.js';
import Macy from 'macy';
import fjGallery from 'flickr-justified-gallery';

import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';
import 'baguettebox.js/dist/baguetteBox.min.css';
import './iconic.css';

var init = function (settings) {
    var config = {
        basePath: '',
        basePathPhp: '/src'
    }
    if (settings) {
        config = {
            ...config,
            ...settings
        }
    }

    const VERSION = "Iconic Gallery Version 1.1.0";
    console.log(VERSION);

    document.querySelectorAll('.iconic-gallery').forEach(function (gallery, index) {
        gallery.dataset.iconicId = index;
        var path = gallery.dataset.iconicPath;
        if (path.includes('#')) {
            path = path.substring(path.indexOf('#') + 1);
        }
        fetch(config.basePath + config.basePathPhp + '/iconic-gallery.php?source=' + gallery.dataset.iconicSource + '&root=' + gallery.dataset.iconicRoot + '&path=' + path)
            .then(response => response.json())
            .then(data => {
                var html = [];
                var basePath = config.basePath;
                if (gallery.dataset.iconicSource === 'icloud') {
                    basePath = '';
                }
                var thumbSrc = 'thumb';
                var sliderSrc = 'url';
                if (gallery.dataset.iconicImageSrc && gallery.dataset.iconicImageSrc == 'full') {
                    thumbSrc = 'url';
                } else if (gallery.dataset.iconicImageSrc && gallery.dataset.iconicImageSrc == 'thumb') {
                    sliderSrc = 'thumb';
                }
                if (['justified', 'masonry', 'flexbox', 'flexbox_square', 'single', 'single_square', 'splider_stack'].includes(gallery.dataset.iconicLayout)) {
                    if (gallery.dataset.iconicSort === 'shuffle') {
                        for (var i = data.length - 1; i > 0; i--) {
                            var j = Math.floor(Math.random() * (i + 1));
                            var temp = data[i];
                            data[i] = data[j];
                            data[j] = temp;
                        }
                    } else if (gallery.dataset.iconicSort === 'descending') {
                        data.sort((x, y) => y.filename.localeCompare(x.filename));
                    }

                    if (['single', 'single_square'].includes(gallery.dataset.iconicLayout)) {
                        data.forEach(function (image, index) {
                            html.push('<a href="' + basePath + image.url + '" data-caption="' + image.caption + '" data-pswp-width="' + image.width + '" data-pswp-height="' + image.height + '">');
                            if (index === 0) {
                                html.push('<figure><img class="iconic-thumb" src="' + basePath + image[thumbSrc] + '" alt="' + image.caption + '" draggable="false"><figcaption class="iconic-caption" >' + image.caption + '</figcaption></figure></a>');
                            } else {
                                html.push('</a>');
                            }
                        });
                    } else {
                        data.forEach(function (image) {
                            html.push('<a href="' + basePath + image.url + '" data-caption="' + image.caption + '" data-pswp-width="' + image.width + '" data-pswp-height="' + image.height + '">');
                            html.push('<figure><img class="iconic-thumb" src="' + basePath + image[thumbSrc] + '" alt="' + image.caption + '" draggable="false"><figcaption class="iconic-caption" >' + image.caption + '</figcaption></figure></a>');
                        });
                    }
                    gallery.innerHTML = html.join('');

                    if (gallery.dataset.iconicLayout === 'justified') {
                        fjGallery(document.querySelectorAll('[data-iconic-id="' + gallery.dataset.iconicId + '"]'), {
                            itemSelector: 'a',
                            gutter: parseInt(gallery.dataset.iconicGutter),
                            rowHeight: parseInt(gallery.dataset.iconicHeight)
                        });
                    }

                    if (gallery.dataset.iconicLayout === 'masonry') {
                        var columns = [2, 3, 4, 5];
                        if (gallery.dataset.iconicColumns) {
                            columns = gallery.dataset.iconicColumns.split(',');
                            columns.forEach(function (e, i, a) {
                                a[i] = parseInt(e);
                            })
                        }
                        new Macy({
                            container: gallery,
                            mobileFirst: true,
                            columns: columns[0],
                            margin: {
                                y: parseInt(gallery.dataset.iconicGutter),
                                x: parseInt(gallery.dataset.iconicGutter)
                            },
                            breakAt: {
                                1200: columns[3],
                                992: columns[2],
                                768: columns[1],
                                576: columns[0]
                            },
                        });
                    }

                    if (gallery.dataset.iconicLayout === 'flexbox') {
                        var style = document.createElement('style');
                        style.innerHTML = '[data-iconic-id="' + index + '"] a {margin: ' + gallery.dataset.iconicGutter / 2 + 'px;} [data-iconic-id="' + index + '"] img { max-height: ' + gallery.dataset.iconicHeight + 'px;}';
                        document.head.appendChild(style);
                    }

                    if (gallery.dataset.iconicLayout === 'flexbox_square') {
                        var style = document.createElement('style');
                        style.innerHTML = '[data-iconic-id="' + index + '"] a {margin: ' + gallery.dataset.iconicGutter / 2 + 'px;} [data-iconic-id="' + index + '"] img { height: ' + gallery.dataset.iconicHeight + 'px; width: ' + gallery.dataset.iconicHeight + 'px;}';
                        document.head.appendChild(style);
                    }

                    if (gallery.dataset.iconicLayout === 'single') {
                        var style = document.createElement('style');
                        style.innerHTML = '[data-iconic-id="' + index + '"] img { max-height: ' + gallery.dataset.iconicHeight + 'px;}';
                        document.head.appendChild(style);
                    }

                    if (gallery.dataset.iconicLayout === 'single_square') {
                        var style = document.createElement('style');
                        style.innerHTML = '[data-iconic-id="' + index + '"] img { height: ' + gallery.dataset.iconicHeight + 'px; width: ' + gallery.dataset.iconicHeight + 'px;}';
                        document.head.appendChild(style);
                    }

                    if (gallery.dataset.iconicLayout === 'splider_stack') {
                        var parentElement = gallery.parentElement;
                        var isLazy = parentElement.parentElement.parentElement.dataset.spliderLazy;
                        var isLoop = parentElement.parentElement.parentElement.classList.contains('splide--loop');
                        var spliderId = parentElement.parentElement.parentElement.dataset.spliderId;
                        var scrAttribute = 'src';
                        if (isLazy && !isLoop) {
                            scrAttribute = 'data-splide-lazy';
                        }
                        var dataset = gallery.dataset;
                        parentElement.dataset.iconicCaptions = dataset.iconicCaptions;
                        parentElement.dataset.iconicCarouselInterval = dataset.iconicCarouselInterval;
                        parentElement.dataset.iconicHeight = dataset.iconicHeight;
                        parentElement.dataset.iconicId = dataset.iconicId;
                        parentElement.dataset.iconicLayout = dataset.iconicLayout;
                        parentElement.dataset.iconicLightbox = dataset.iconicLightbox;
                        parentElement.dataset.iconicLightboxBgcolor = dataset.iconicLightboxBgcolor;
                        parentElement.dataset.iconicLightboxCaptions = dataset.iconicLightboxCaptions;
                        parentElement.removeChild(gallery);
                        data.forEach(function (image, index) {
                            html = [];
                            html.push('<div class="splide__slide"><img ' + scrAttribute + '="' + basePath + image[sliderSrc] + '" alt="' + image.caption + '" draggable="false"></img>');
                            if (dataset.iconicCaptions === '1') {
                                html.push('<div class="splide__caption">' + image.caption + '</div>')
                            }
                            if (dataset.iconicLightbox !== '') {
                                html.push('<div class="s-slide-link"><a href="' + basePath + image.url + '" data-caption="' + image.caption + '" data-pswp-width="' + image.width + '" data-pswp-height="' + image.height + '"></a></div>');
                            }
                            html.push('</div>');
                            window[spliderId].add(html.join(''));
                        });
                        gallery = document.querySelectorAll("[data-iconic-id='" + dataset.iconicId + "']")[0];
                    }

                    if (gallery.dataset.iconicLightbox === 'baguettebox') {
                        var color = 'rgba(0,0,0,0.8)';
                        if (gallery.dataset.iconicLightboxBgcolor === 'light') {
                            color = 'rgba(255,255,255,0.8)';
                        }
                        baguetteBox.run('[data-iconic-id="' + gallery.dataset.iconicId + '"]', {
                            captions: gallery.dataset.iconicLightboxCaptions === '1' ? true : false,
                            overlayBackgroundColor: color,
                            noScrollbars: true,
                            // animation: 'slideIn',
                            filter: /.+\.(gif|jpe?g|png|webp|avif)/i
                        });
                    }

                    if (gallery.dataset.iconicLightbox === 'photoswipe') {
                        if (gallery.dataset.iconicLightboxBgcolor === 'light') {
                            var style = document.createElement('style');
                            style.innerHTML = '.pswp--iconic-' + gallery.dataset.iconicId + ' .pswp__bg {background: white;} .pswp--iconic-' + gallery.dataset.iconicId + ' .pswp__dynamic-caption {color: black;}';
                            document.head.appendChild(style);
                        }
                        var lightbox = new PhotoSwipeLightbox({
                            gallery: gallery,
                            children: 'a',
                            pswpModule: () => PhotoSwipe,
                            paddingFn: (viewportSize, itemData, index) => {
                                if (gallery.dataset.iconicLightboxCaptions === '1') {
                                    return {
                                        top: 30, bottom: 30, left: 70, right: 70
                                    }
                                } else {
                                    return {
                                        top: 0, bottom: 0, left: 0, right: 0
                                    }
                                }
                            },
                            mainClass: 'pswp--iconic-' + gallery.dataset.iconicId
                        });
                        if (gallery.dataset.iconicLightboxCaptions === '1') {
                            var captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
                                type: 'auto',
                                captionContent: (slide) => {
                                    return slide.data.element.dataset.caption;
                                }
                            });
                        }
                        lightbox.init();
                    }
                }

                if (gallery.dataset.iconicLayout === 'carousel') {
                    gallery.id = 'iconic-gallery-' + gallery.dataset.iconicId;
                    gallery.classList.add('carousel')
                    gallery.classList.add('slide');
                    gallery.dataset.ride = 'carousel';
                    gallery.dataset.bsRide = 'carousel';
                    var interval = 5000;
                    if (gallery.dataset.iconicCarouselInterval) {
                        interval = parseInt(gallery.dataset.iconicCarouselInterval) * 1000;
                    }
                    gallery.dataset.bsInterval = interval;
                    html.push('<ol class="carousel-indicators">');
                    data.forEach(function (image, index) {
                        html.push('<li data-target="#' + gallery.id + '" data-bs-target="#' + gallery.id + '" data-slide-to="' + index + '" data-bs-slide-to="' + index + '"');
                        if (index === 0) {
                            html.push(' class="active" aria-current="true" ');
                        }
                        html.push('aria-label="' + image.caption + '"></li>');
                    });
                    html.push('</ol>');
                    html.push('<div class="carousel-inner">');
                    data.forEach(function (image, index) {
                        html.push('<div class="carousel-item ');
                        if (index === 0) {
                            html.push('active');
                        }
                        html.push('">');
                        html.push('<img src="' + basePath + image[sliderSrc] + '" class="d-block w-100" alt="' + image.caption + '" draggable="false">');
                        if (gallery.dataset.iconicCaptions === '1') {
                            html.push('<div class="carousel-caption d-none d-md-block"><p>' + image.caption + '</p></div>');
                        }
                        html.push('</div>');
                    });
                    html.push('</div>');
                    html.push('<button class="carousel-control-prev" type="button" data-target="#' + gallery.id + '" data-bs-target="#' + gallery.id + '" data-slide="prev" data-bs-slide="prev">');
                    html.push('<span class="carousel-control-prev-icon" aria-hidden="true"></span>');
                    html.push('<span class="sr-only visually-hidden">Previous</span></button>');
                    html.push('<button class="carousel-control-next" type="button" data-target="#' + gallery.id + '" data-bs-target="#' + gallery.id + '" data-slide="next" data-bs-slide="next">');
                    html.push('<span class="carousel-control-next-icon" aria-hidden="true"></span>');
                    html.push('<span class="sr-only visually-hidden">Next</span></button>');
                    gallery.innerHTML = html.join('');
                    var style = document.createElement('style');
                    style.innerHTML = '[data-iconic-id="' + index + '"] img {height: ' + gallery.dataset.iconicHeight + 'px !important;}';
                    document.head.appendChild(style);
                }

                if (gallery.dataset.iconicLayout === 'orbit') {
                    gallery.id = 'iconic-gallery-' + gallery.dataset.iconicId;
                    gallery.classList.add('orbit')
                    gallery.setAttribute('role', 'region');
                    gallery.dataset.orbit = '';
                    var interval = 5000;
                    if (gallery.dataset.iconicCarouselInterval) {
                        interval = parseInt(gallery.dataset.iconicCarouselInterval) * 1000;
                    }
                    gallery.dataset.timerDelay = interval;
                    html.push('<div class="orbit-wrapper">');
                    html.push('<div class="orbit-controls"><button class="orbit-previous"><span class="show-for-sr">Previous Slide</span>&#9664;&#xFE0E;</button><button class="orbit-next"><span class="show-for-sr">Next Slide</span>&#9654;&#xFE0E;</button></div>');
                    html.push('<ul class="orbit-container">');
                    data.forEach(function (image, index) {
                        html.push('<li class="orbit-slide ');
                        if (index === 0) {
                            html.push('is-active');
                        }
                        html.push('">');
                        html.push('<figure class="orbit-figure"><img class="orbit-image" src="' + basePath + image[sliderSrc] + '" alt="' + image.caption + '" draggable="false">');
                        if (gallery.dataset.iconicCaptions === '1') {
                            html.push('<figcaption class="orbit-caption">' + image.caption + '</figcaption>');
                        }
                        html.push('</figure></li>');
                    });
                    html.push('</ul>');
                    html.push('</div>');
                    html.push('<nav class="orbit-bullets">');
                    data.forEach(function (image, index) {
                        if (index === 0) {
                            html.push('<button class="is-active" data-slide="' + index + '"><span class="show-for-sr">' + image.caption + '</span><span class="show-for-sr" data-slide-active-label>Current Slide</span></button>');
                        } else {
                            html.push('<button data-slide="' + index + '"><span class="show-for-sr">' + image.caption + '</span></button>');
                        }
                    });
                    html.push('</nav>');
                    gallery.innerHTML = html.join('');
                    var style = document.createElement('style');
                    style.innerHTML = '[data-iconic-id="' + index + '"] img {height: ' + gallery.dataset.iconicHeight + 'px !important;}';
                    document.head.appendChild(style);
                    new Foundation.Orbit($('#' + gallery.id));
                }

                if (gallery.dataset.iconicProtect === '1') {
                    document.body.addEventListener('contextmenu', function (e) {
                        if (e.target.tagName.toLowerCase() === 'img') {
                            e.preventDefault();
                        }
                    });
                }

            });
    });

    document.querySelectorAll('.iconic-repository').forEach(function (repository, index) {
        repository.href = repository.href + '#' + repository.dataset.iconicPath;
    });

}

export { init };